
import { Component, Vue, Model, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
@Component({
  components: {}
})
export default class PiSelectTableData extends Vue {
  @Prop({ default: true }) private getShow!: boolean;
  @Prop({ default: true }) private modalBtnShow!: boolean;
  @Prop({ default: true }) private queryShow!: boolean;
  @Prop({ default: false }) private exportBtn!: boolean;

  @Prop({
    default: () => {
      return [];
    }
  })
  private allTableData!: object[];
  @Model("value", { type: Array }) private modelValue!: object[];

  private selectValue: string[] = [];
  private exportSelectValue: string[] = [];

  private modalShow = false;
  private exportModalShow = false;
  public openModal() {
    this.modalShow = true;
  }

  public checkChange(val: string[]) {
    const arr: object[] = [];
    this.allTableData.map((item: objAny) => {
      if (val.indexOf(item.key) != -1) {
        arr.push(item);
      }
    });
    this.$emit("value", arr);
  }

  public getTable() {
    this.$emit("get");
  }
  public queryClick() {
    this.$emit("query");
  }
  public exportCheckChange(val: string[]) {
    this.$emit("exportChange", val);
  }
  mounted() {
    // this.allTableData = JSON.parse(JSON.stringify(this.modelValue));
    const arr: object[] = [];
    const selectValue: string[] = [];
    this.allTableData.map((item: objAny) => {
      if (item.show === true || item.show === undefined) {
        arr.push(item);
        selectValue.push(item.key);
      }
    });
    this.selectValue = selectValue;
    this.exportSelectValue = selectValue;
    this.$emit("value", arr);
  }
}
